<!--
    描述：新增、编辑菜单弹框等
    时间：2020-04-22
    Created by zwh
-->
<template>
    <div class="">
        <el-form :model="objectForm" :rules="formRules" ref="objectForm" label-width="100px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="上级菜单" prop="parentName" :show-message="false">
                        <el-input v-if="transObj.type=='addParent' || transObj.type=='edit'" v-model="objectForm.parentName" disabled autocomplete="off">
                             <el-button slot="append" disabled icon="el-icon-plus" @click="addClick('selectParentMenu')"></el-button>
                        </el-input>
                        <el-input v-if="transObj.type=='addSon'" v-model="objectForm.parentName" disabled autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="菜单名称" prop="sname" :show-message="false">
                        <el-input v-model="objectForm.sname" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="菜单类型" prop="menuType" :show-message="false">
                        <el-select v-model="objectForm.menuType" placeholder="">
                            <el-option label="目录" :value="0"></el-option>
                            <el-option label="菜单" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="路由路径" prop="path" :show-message="false">
                        <el-input v-model="objectForm.path" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="组件地址" prop="componentPath" :show-message="false">
                        <el-input v-model="objectForm.componentPath" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="组件名称" prop="componentName" :show-message="false">
                        <el-input v-model="objectForm.componentName" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="菜单URL" prop="url" :show-message="false">
                        <el-input v-model="objectForm.url" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="是否隐藏" prop="isHidden" :show-message="false">
                        <el-radio v-model="objectForm.isHidden" :label="0">否</el-radio>
                        <el-radio v-model="objectForm.isHidden" :label="1">是</el-radio>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="菜单图标" prop="icon" :show-message="false">
                        <el-input v-model="objectForm.icon" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="底纹" prop="shading" :show-message="false">
                        <el-input v-model="objectForm.shading" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="菜单层级" prop="level" :show-message="false">
                        <el-input v-model="objectForm.level" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="菜单状态" prop="optionType" :show-message="false">
                        <el-select v-model="objectForm.optionType" placeholder="">
                            <el-option label="静态" value="0"></el-option>
                            <el-option label="动态" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item type="number" label="排序" prop="sortNum" :show-message="false">
                        <el-input v-model="objectForm.sortNum" autocomplete="off" :disabled="isDisabled"
                                  :show-message="false"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="备注信息" prop="remark" :show-message="false">
                        <el-input type="textarea" v-model="objectForm.remark" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <!-- 新增、编辑等弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width"
                   :close-on-click-modal="false" @closed="handleClose" append-to-body>
            <!-- 弹窗组件 -->
            <menuTree ref="menuTree" v-if="dialogObj.visible"
                @handle-select-parent-menu="handleSelectParentMenu"
            ></menuTree>
            <!-- footer 组件 -->
            <div slot="footer" class="dialog-footer text-center" v-if="dialogObj.mode !== 'view'">
                <el-button size="small" @click="dialogObj.visible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="btnLoading" @click="doSaveParentMenu">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import menuTree from './menu_tree_dialog'
    import {saveOrUpdate,getInfoById} from '@/api/modules/menu.js'
    export default {
        components: {menuTree},
        props : {
            mode: {
                type: String,
                default: 'add'
            },
            transObj: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                parentClickTreeNode : '',

                btnLoading: false,
                objectForm: {
                    id : '',
                    parentId : '',
                    parentName : '',
                    sname: '',
                    url : '',
                    menuType : '',
                    componentPath : '',
                    componentName : '',
                    isHidden : 0,
                    path : '',
                    icon :'',
                    shading : '',
                    level : '',
                    optionType : '',

                    sortNum: '',

                    remark : '',
                },
                formRules: {
                    // sname: [{required: true, message: '请输入...', trigger: 'blur'}],
                    url: [{required: true, message: '请输入...', trigger: 'blur'}],
                    menuType: [{required: true, message: '请选择...', trigger: 'change'}],
                    componentPath: [{required: true, message: '请输入...', trigger: 'blur'}],
                    componentName: [{required: true, message: '请输入...', trigger: 'blur'}],
                    isHidden: [{ required: true, message: '请选择...', trigger: 'change' }],
                    path: [{required: true, message: '请输入...', trigger: 'blur'}],
                    optionType: [{required: true, message: '请选择...', trigger: 'change'}],
                    sortNum: [{required: true, message: '请输入...', trigger: 'blur'}],
                },

                dialogObj: {
                    title: '',
                    visible: false,
                    width: '650px',
                    mode: 'add',
                },
            }
        },
        methods: {
            //点击确定按钮事件
            doSave() {
                let that = this
                this.$refs['objectForm'].validate((valid) => {
                  if (valid) {
                    let param = this.objectForm;
                    saveOrUpdate(param).then(res => {
                        if(res.operationCode==1){
                            that.$message({message: '保存成功',type: 'success'});
                            //刷新菜单信息
                            that.$emit('handle-success')
                        }
                    });
                  } else {
                    return false;
                  }
                });
            },
            // 查看、编辑初始渲染数据
            getObjectById() {
                let that = this
                let param = { id : this.objectForm.id + '' }
                getInfoById(param).then(res => {
                    if(res.operationCode==1){
                        res.data != null && res.data != '' ? this.objectForm = res.data : ''
                        this.objectForm.optionType = this.objectForm.optionType != null ? this.objectForm.optionType + '' : ''
                    }
                });
            },

            addClick(type){
                this.dialogObj.title = '菜单信息';
                this.dialogObj.visible = true;
            },

            // 关闭弹窗事件
            handleClose() {

            },
            handleSelectParentMenu(obj){
                this.parentClickTreeNode = obj
            },
            doSaveParentMenu(){
                if(this.parentClickTreeNode=='' || typeof(this.parentClickTreeNode)=='undefined'){
                    this.$message({message: '请选择菜单信息',type: 'warning'});
                    return
                }

                if(this.objectForm.id == this.parentClickTreeNode.id){
                    this.$message({message: '不能选择自身作为父级菜单',type: 'warning'});
                    return
                }

                this.objectForm.parentId = this.parentClickTreeNode.id
                this.objectForm.parentName = this.parentClickTreeNode.sname

                this.dialogObj.visible = false
            },
        },
        created() {
            this.objectForm.id = this.transObj.id
            this.objectForm.parentId = this.transObj.parentId
            this.objectForm.parentName = this.transObj.parentName
            if (this.mode !== 'add') {
                this.getObjectById()
            }
        },
        computed: {
            // 是否可编辑
            isDisabled() {
                return this.mode === 'view' ? true : false
            }
        }
    }
</script>

<style scoped lang="less">
    div .el-input-group__append, .el-input-group__prepend {
        background-color: #000;
        color: #909399;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 0 20px;
        width: 1px;
        white-space: nowrap;
    }
</style>
